import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gesture-click"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.7555 11.519V7.56525C12.7555 6.59561 11.9694 5.80957 10.9998 5.80957C10.0302 5.80957 9.24412 6.59561 9.24412 7.56524V16.3501L5.88164 15.6024C5.5274 15.5237 5.1612 15.6708 4.95999 15.9728L4.41602 16.7893L8.27779 21.8127C8.61032 22.2453 9.12496 22.4988 9.67056 22.4988H16.7561C17.5123 22.4988 18.1837 22.0147 18.4228 21.2972L20.2052 15.9467C20.4679 15.1581 20.1419 14.2933 19.4241 13.8743L15.7994 11.7586C15.5306 11.6017 15.225 11.519 14.9138 11.519H12.7555Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9.24412 16.3511V7.56622C9.24412 6.59659 10.0302 5.81055 10.9998 5.81055C11.9694 5.81055 12.7555 6.59659 12.7555 7.56622V11.52H14.9138C15.0767 11.52 15.2381 11.5427 15.3935 11.5868C15.5349 11.6269 15.6713 11.6848 15.7994 11.7596L19.4241 13.8752C20.1419 14.2943 20.4679 15.1591 20.2052 15.9477L18.4228 21.2982C18.1837 22.0157 17.5123 22.4997 16.7561 22.4997H9.67056C9.12496 22.4997 8.61032 22.2462 8.27779 21.8137L4.41602 16.7903L4.95999 15.9738C5.1612 15.6718 5.5274 15.5246 5.88164 15.6034L9.24412 16.3511Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6 5.49902L5 4.49902M16 5.49902L17 4.49902M11 2.91421V1.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GestureClick = Vue.extend<IconProps>({
  name: 'GestureClickIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-click',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GestureClick;
